import React, {Component, Fragment} from 'react';
import {getRentalBookings} from '../../api/bookingApi';
import {Link, NavLink} from 'react-router-dom';
import PropTypes from 'prop-types';
import axios from 'axios';
import 'react-datepicker/dist/react-datepicker.css';
import {passCsrfToken, ifNotZero, getDuration} from '../../helpers';
import moment from 'moment';
import {EmptyContent} from '../shared';
import {Badge} from '../shared';
import swal from 'sweetalert';
import {Timer} from '../shared';
import {PaymentForm} from '../payments';

class RentalBookings extends Component {
	constructor(props) {
		super(props);

		this.state = {
			bookings: [],
			refresh: false
		};
	}

	componentDidMount() {
		passCsrfToken(document, axios);
		this.fetchDetails();
	}

	componentWillUnmount() {}

	fetchDetails = (params) => {
		getRentalBookings()
			.then((response) => {
				console.log('Rental Bookings List', response);
				this.setState({
					bookings: response.data?.car_bookings || []
				});
			})
			.catch((error) => {
				// console.log(error);
				this.setState({
					error
				});

				console.log(' Package Booking List fetch error', error);
			});
	};

	render() {
		const { bookings } = this.state;
		const list = Array.isArray(bookings) ? bookings : [];
		if (list.length === 0) {
			return <EmptyContent>No Rental Bookings yet.</EmptyContent>;
		}

		return (
			<div className=''>
				{list.map((booking) => {
					const status = booking.status || 'pending';
					const badgeType = status === 'verified' || status === 'completed' || status === 'approved' ? 'success' : 
									  status === 'processing' ? 'info' : 
									  status === 'pending' ? 'warning' : 'secondary';
					
					return (
						<div key={booking.idx} className='booking-card'>
							<div className="booking-card__header">
								<h3 className="booking-card__title">{booking.car_inquiry?.car_type || 'Car Rental'}</h3>
								<div className="booking-card__meta">
									{booking.start_date && (
										<div className="booking-card__meta-item">
											<i className="fas fa-calendar-alt" />
											<span>{moment(booking.start_date).format('Do MMM, YYYY')}</span>
										</div>
									)}
									{booking.car_inquiry?.no_of_days && (
										<div className="booking-card__meta-item">
											<i className="fas fa-clock" />
											<span>{booking.car_inquiry.no_of_days} {booking.car_inquiry.no_of_days === 1 ? 'day' : 'days'}</span>
										</div>
									)}
								</div>
							</div>
							<div className="booking-card__footer">
								<div className="booking-card__status">
									<span className={`booking-card__badge booking-card__badge--${badgeType}`}>
										{status.charAt(0).toUpperCase() + status.slice(1)}
									</span>
								</div>
								<div className="booking-card__actions">
									{(status === 'completed' || status === 'verified' || status === 'approved') && (
										<Link 
											to={{ pathname: `/car_bookings/${booking.idx}` }} 
											className="booking-card__action-btn booking-card__action-btn--primary"
										>
											<i className="fas fa-ticket-alt" />
											View Ticket
										</Link>
									)}
									{(status === 'pending' || status === 'processing') && (
										<Link 
											to={{ pathname: `/car_bookings/${booking.idx}` }} 
											className="booking-card__action-btn booking-card__action-btn--primary"
										>
											<i className="fas fa-eye" />
											View Details
										</Link>
									)}
								</div>
							</div>
						</div>
					);
				})}
			</div>
		);
	}
}

export default RentalBookings;
